<template>
  <div class="topbar-item">
    <template v-if="showTeamArea">
      <div class="spacer"></div>
      <div class="nodes" @click="changeVisibilityTeam">
        <i class="fas fa-address-card"></i>
        <div class="info">
          <div
            :class="[
              'd-flex align-items-center',
              { light: selectedTeam != '' },
            ]"
          >
            <div>{{ $t('global.team') }}</div>
            <a
              class="ml-3"
              href="javascript:;"
              v-if="selectedTeam != ''"
              @click="destroyTeam"
            >
              <i
                class="far fa-times-circle text-danger font-weight-normal mt-1"
              ></i>
            </a>
          </div>
          <div v-if="selectedTeam != ''" class="nav-font-sm">
            {{ selectedTeam.name }}
          </div>
        </div>
        <i
          :class="[
            'gray-icon fas',
            {
              'fa-chevron-down': !showTeams,
              'fa-chevron-up': showTeams,
            },
          ]"
        ></i>
      </div>
    </template>

    <UserTeams />
    <div class="spacer"></div>
    <div class="nodes" @click="changeVisibilityDataCenterNode">
      <i class="fas fa-server"></i>
      <div class="info">
        <div
          :class="[
            'd-flex align-items-center',
            { light: selectedDataCenterNode != '' },
          ]"
        >
          <div>{{ $t('datacenter.dataCenterNode') }}</div>
          <a
            class="ml-3"
            href="javascript:;"
            v-if="selectedDataCenterNode != ''"
            @click="destroyDataCenterNode"
          >
            <i
              class="far fa-times-circle text-danger font-weight-normal mt-1"
            ></i>
          </a>
        </div>
        <div v-if="selectedDataCenterNode != ''">
          {{ selectedDataCenterNode }}
        </div>
      </div>
      <i
        :class="[
          'gray-icon fas',
          {
            'fa-chevron-down': !showDataCenterNode,
            'fa-chevron-up': showDataCenterNode,
          },
        ]"
      ></i>
    </div>

    <!-- TopBar Discord Alanı -->
    <template v-if="discordUrl != ''">
      <div class="spacer mr-0"></div>
      <div class="dcTopLogo">
        <a target="_blink" :href="discordUrl">
          <img
            src="/image/TopLogoDiscord.svg"
            class="dcLogos"
            alt="Discord Topluluk"
          />
        </a>
      </div>
    </template>
    <!-- TopBar Community Alanı -->
    <template v-if="communityUrl != ''">
      <div class="spacer mr-4"></div>
      <div class="Community mr-4">
        <a target="_blink" :href="`${communityUrl}`">
          <i class="fas fa-users CommunityIcon"> </i>
        </a>
      </div>
    </template>
    <div class="spacer"></div>
    <!-- <div class="help">
      <i class="fas fa-life-ring"></i>
    </div>

    <div class="notification"
         @click="showNotificationModal=true">
      <i class="fas fa-bell"></i>
    </div>

    <div class="notification"
         @click="notificationTest">
      <i class="fas fa-info-circle"></i>
    </div> -->

    <div
      class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
      id="kt_quick_user_toggle"
    >
      <span
        class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1"
      >
        {{ $t('global.hello') }},
      </span>
      <span
        class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3"
      >
        {{ currentUser.user.fullname }}
      </span>
      <span class="symbol symbol-35 symbol-light-success">
        <span class="symbol-label font-size-h5 font-weight-bold">
          {{ currentUser.user.fullname.slice(0, 1) }}
        </span>
      </span>
    </div>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-right"
    >
      <!--begin::Header-->
      <div
        class="offcanvas-header d-flex align-items-center justify-content-between p-5"
      >
        <h3 class="font-weight-bold m-0">
          {{ currentUser.user.fullname }}
        </h3>
        <a
          href="#"
          class="d-flex btn btn-xs btn-light p-2 rounded-sm"
          id="kt_quick_user_close"
          ref="quick_user_close"
        >
          <i class="far fa-times-circle p-0"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content pr-5 mr-n5 scroll"
        style="max-height: 90vh; position: relative"
      >
        <!--begin::Header-->
        <div class="separator separator-solid"></div>
        <div class="d-flex align-items-center p-5">
          <div class="d-flex flex-column">
            <span class="font-weight-bold font-size-h5 text-dark-75">
              {{ $t('global.languageSelection') }}
            </span>

            <div class="lang-buttons mt-3">
              <div v-for="(item, i) in langs" :key="`lang-${i}`" class="lang">
                <button
                  class="btn btn-hover-light-primary rounded-sm font-weight-normal"
                  :class="
                    $i18n.locale == item.lang
                      ? 'btn-light-primary'
                      : 'btn-light-muted'
                  "
                  @click="selectedLanguage(item)"
                >
                  {{ item.name }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="separator separator-solid"></div>
        <div class="d-flex align-items-center p-5">
          <button class="btn btn-light-info btn-bold text-primary">
            <i class="fas fa-key sidebar-icon-black"></i>
          </button>
          <router-link
            to="/personal-access-token"
            class="sidebar-text-black pl-3"
          >
            {{ $t('token.personalAccessTokens') }}</router-link
          >
        </div>

        <div class="separator separator-solid"></div>

        <div class="d-flex align-items-center p-5">
          <button class="btn btn-light-danger btn-bold" @click="onLogout">
            <i class="fas fa-sign-out-alt sidebar-icon"></i>
          </button>
          <a href="#" @click="onLogout" class="sidebar-text pl-3 text-danger">
            {{ $t('auth.signOut') }}
          </a>
        </div>

        <div class="separator separator-solid"></div>
        <!--end::Header-->
      </perfect-scrollbar>
      <!--end::Content-->
    </div>

    <NotificationModal
      :show="showNotificationModal"
      @closeDetail="closeNotificationModal()"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import i18nService from '@/core/services/i18n.service.js'
import { LOGOUT } from '@/core/services/store/auth.module'
import KTLayoutQuickUser from '@/assets/js/layout/extended/quick-user.js'
import EventBus from '@/event-bus'
import JwtService from '@/core/services/jwt.service'

export default {
  name: 'KTQuickUser',
  data() {
    return {
      langs: i18nService.languages,
      showDataCenterNode: false,
      selectedDataCenterNode: '',
      showNotificationModal: false,
      notificationCount: 0,
      showTeamArea: false,
      showTeams: false,
      selectedTeam: '',
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    discordUrl() {
      return process.env.VUE_APP_DISCORD_URL &&
        process.env.VUE_APP_DISCORD_URL != ''
        ? process.env.VUE_APP_DISCORD_URL
        : ''
    },
    communityUrl() {
      return process.env.VUE_APP_COMMUNITY_URL &&
        process.env.VUE_APP_COMMUNITY_URL != ''
        ? process.env.VUE_APP_COMMUNITY_URL
        : ''
    },
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs['kt_quick_user'])

    let currentDataCenterNode = JwtService.getSelectedDataCenterNode()
    if (currentDataCenterNode) {
      this.selectedDataCenterNode = currentDataCenterNode.name
    }

    let currentTeam = JwtService.getUserTeam()
    if (currentTeam && currentTeam.id != '') {
      this.selectedTeam = currentTeam
    }
    EventBus.$on(`nodeSelect`, this.listenernodeSelect)
    EventBus.$on(`teamSelect`, this.listenerteamSelect)
    EventBus.$on(`showTeamArea`, this.listenershowTeamArea)
    EventBus.$on(`teamClose`, this.listenerteamClose)
    EventBus.$on(`dataCenterNodeClose`, this.listenerdataCenterNodeClose)
  },
  beforeDestroy() {
    EventBus.$off(`nodeSelect`, this.listenernodeSelect)
    EventBus.$off(`teamSelect`, this.listenerteamSelect)
    EventBus.$off(`showTeamArea`, this.listenershowTeamArea)
    EventBus.$off(`teamClose`, this.listenerteamClose)
    EventBus.$off(`dataCenterNodeClose`, this.listenerdataCenterNodeClose)
  },
  methods: {
    listenernodeSelect(payload) {
      this.selectedDataCenterNode = payload
    },
    listenerteamSelect(payload) {
      this.selectedTeam = payload
    },
    listenershowTeamArea(payload) {
      this.showTeamArea = payload
    },
    listenerteamClose(payload) {
      this.showTeams = false
    },
    listenerdataCenterNodeClose(payload) {
      this.showDataCenterNode = false
    },
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: 'login' }))
    },
    selectedLanguage(lang) {
      this.$i18n.locale = lang.lang
      i18nService.setActiveLanguage(this.$i18n.locale)
      this.$store.dispatch('setCurrentLang', this.$i18n.locale)
    },
    changeVisibilityDataCenterNode() {
      if (this.showTeams) this.changeVisibilityTeam()

      this.showDataCenterNode = !this.showDataCenterNode
      EventBus.$emit('changeVisibilityDataCenterNode', this.showDataCenterNode)
    },
    destroyDataCenterNode() {
      JwtService.destroySelectedDataCenterNode()
      this.selectedDataCenterNode = ''
      EventBus.$emit('changeVisibilityDataCenterNode')
      this.redirectAfterChange()
    },
    changeVisibilityTeam() {
      if (this.showDataCenterNode) this.changeVisibilityDataCenterNode()

      this.showTeams = !this.showTeams
      EventBus.$emit('changeVisibilityTeam', this.showTeams)
    },
    destroyTeam() {
      JwtService.destroyUserTeam()
      // this.selectedTeam = ''
      EventBus.$emit('changeVisibilityTeam')
      this.redirectAfterChange()
    },
    redirectAfterChange() {
      let current = this.$router.currentRoute.fullPath.split('/')
      if (current.length > 3) {
        this.$router.push(`/${current[1]}/${current[2]}`)
      } else {
        this.$router.go(0)
      }
    },
    notificationTest() {
      if (this.notificationCount++ % 2 == 0) {
        EventBus.$emit('notificationError', {
          title: 'Başlık',
          description: 'İçerik : www.google.com',
          url: 'javascript:;',
          urlTitle: 'Deneme',
        })
      } else {
        EventBus.$emit('notificationError', {
          title: 'Başlık',
          description: 'Lorem ipsum bla bla',
        })
      }
    },
    closeNotificationModal() {
      this.showNotificationModal = false
    },
  },
  watch: {
    $route(to, from) {
      this.showDataCenterNode = false
      EventBus.$emit('changeVisibilityDataCenterNode', this.showDataCenterNode)

      this.showTeams = false
      EventBus.$emit('changeVisibilityTeam', this.showTeams)
    },
  },
  components: {
    NotificationModal: () => import('@/components/NotificationModal'),
    UserTeams: () => import('@/components/UserTeams'),
  },
}
</script>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
  .lang-buttons {
    display: flex;
    align-items: center;

    span {
      margin-right: 8px;
    }

    .lang {
      margin-right: 16px;
      cursor: pointer;

      img {
        width: 32px;
      }

      &:last-child {
        margin-right: 8px;
      }
    }
  }
  #kt_quick_user_close {
    i {
      color: #f64e60 !important;
      font-size: 15px;
    }
  }
  .btn-light-info:hover {
    background-color: #d0b6ff;
  }
  .btn.btn-light-info i {
    color: #3699ff;
  }
  .btn-yellow-info {
    background-color: #fca326;
  }
  .btn-yellow-info:hover {
    background-color: #ef8b00;
  }
  .btn.btn-yellow-info i {
    color: #ffffff;
  }
  .sidebar-icon {
    opacity: 0.5;
    padding: 5px 0px;
  }
  .sidebar-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
  }
  .sidebar-icon-black {
    padding: 5px 0px;
  }
  .sidebar-text-black {
    color: #6c7293;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
    // width: 180px;
  }
  .CommunityIcon {
    font-size: 22px;
    color: #888;
    &:hover {
      color: #7389da !important;
    }
  }
}
</style>
